import * as styles from "./SectionCentreVolunteerRoles.module.scss";

import React from "react";

import VolunteerVacancyCardSimple from "../../../components/SignPostCards/VolunteerVacancySimpleCard/VolunteerVacancySimpleCard";
import { Button } from "../../../components/common";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionCentreVolunteerRolesProps {
	title: string;
	introText: string;
	vacancies: Queries.VolunteerVacancyDataFragment[];
}

export const SectionCentreVolunteerRoles: React.FC<
	SectionCentreVolunteerRolesProps
> = ({ title, introText, vacancies }) => {
	return (
		<WrappedSection
			sectionName="SectionCentreVolunteerRoles"
			sectionColour={Colours.SANDY_FUR}
		>
			<div className={styles.centrevolunteeringrolesinner}>
				<div className={styles.titlewrapper}>
					<h2 className={styles.title}>{title}</h2>
				</div>
				<div className={styles.introtext}>
					<p>{introText}</p>
				</div>
				<div className={styles.ctacontainer}>
					<Button
						variant="secondary"
						url={"/support-us/volunteering/vacancies"}
						fullWidth={true}
					>
						View all volunteering opportunities
					</Button>
				</div>
				<div className={styles.volunteeringresultscontainer}>
					{vacancies.map((vacancy) => (
						<VolunteerVacancyCardSimple
							key={vacancy.title}
							date={vacancy.field_date}
							title={vacancy.title}
							url={vacancy.path.alias}
						/>
					))}
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionCentreVolunteerRoles;
